import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { COAListPage } from './pages/coa/COAListPage';
import { COAFormPage } from './pages/coa/COAFormPage';
import { COADetailPage } from './pages/coa/COADetailPage';
import { ReceiveVoucherList } from './pages/voucher/receive/ReceiveVoucherList';
import { ReceiveVoucherCreate } from './pages/voucher/receive/ReceiveVoucherCreate';
import { PaymentVoucherList } from './pages/voucher/payment/PaymentVoucherList';
import { PaymentVoucherCreate } from './pages/voucher/payment/PaymentVoucherCreate';
import { JournalList } from './pages/voucher/journal/JournalList';
import { JournalCreate } from './pages/voucher/journal/JournalCreate';
import { BankTransactionList } from './pages/bank-transaction/BankTransactionList';
import { BankTransactionCreate } from './pages/bank-transaction/BankTransactionCreate';
import { BillPaymentList } from './pages/bill-payment/BillPaymentList';
import { BillPaymentCreate } from './pages/bill-payment/BillPaymentCreate';
import { AllVouchersList } from './pages/voucher/all/AllVouchersList';
import { PartyListPage } from './pages/party/PartyListPage';
import { PartyFormPage } from './pages/party/PartyFormPage';
import { BankAccountList } from './pages/bank-account/BankAccountList';
import { BankAccountForm } from './pages/bank-account/BankAccountForm';
import { PlaceholderPage } from './pages/PlaceholderPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-4" />} data-id="element-3" />
          <Route path="/dashboard" element={<DashboardPage data-id="element-6" />} data-id="element-5" />

          {/* COA Routes */}
          <Route path="/coa" element={<COAListPage data-id="element-8" />} data-id="element-7" />
          <Route path="/coa/new" element={<COAFormPage data-id="element-10" />} data-id="element-9" />
          <Route path="/coa/:id" element={<COADetailPage data-id="element-12" />} data-id="element-11" />
          <Route path="/coa/:id/edit" element={<COAFormPage data-id="element-14" />} data-id="element-13" />

          {/* Bank Account Routes */}
          <Route path="/bank-accounts" element={<BankAccountList data-id="element-16" />} data-id="element-15" />
          <Route path="/bank-accounts/new" element={<BankAccountForm data-id="element-18" />} data-id="element-17" />
          <Route path="/bank-accounts/:id" element={<PlaceholderPage title="Bank Account Detail" description="View bank account details" data-id="element-20" />} data-id="element-19" />
          <Route path="/bank-accounts/:id/edit" element={<BankAccountForm data-id="element-22" />} data-id="element-21" />

          {/* Receive Voucher Routes */}
          <Route path="/voucher/receive" element={<ReceiveVoucherList data-id="element-24" />} data-id="element-23" />
          <Route path="/voucher/receive/create" element={<ReceiveVoucherCreate data-id="element-26" />} data-id="element-25" />

          {/* Payment Voucher Routes */}
          <Route path="/voucher/payment" element={<PaymentVoucherList data-id="element-28" />} data-id="element-27" />
          <Route path="/voucher/payment/create" element={<PaymentVoucherCreate data-id="element-30" />} data-id="element-29" />

          {/* Journal Voucher Routes */}
          <Route path="/voucher/journal" element={<JournalList data-id="element-32" />} data-id="element-31" />
          <Route path="/voucher/journal/create" element={<JournalCreate data-id="element-34" />} data-id="element-33" />

          {/* Bank Transaction Routes */}
          <Route path="/bank-transaction" element={<BankTransactionList data-id="element-36" />} data-id="element-35" />
          <Route path="/bank-transaction/create" element={<BankTransactionCreate data-id="element-38" />} data-id="element-37" />
          <Route path="/bank-transaction/:id" element={<PlaceholderPage title="Bank Transaction Detail" description="View bank transaction details" data-id="element-40" />} data-id="element-39" />
          <Route path="/bank-transaction/:id/edit" element={<PlaceholderPage title="Edit Bank Transaction" description="Edit pending bank transaction" data-id="element-42" />} data-id="element-41" />

          {/* Bill Payment Routes */}
          <Route path="/bill-payment" element={<BillPaymentList data-id="element-44" />} data-id="element-43" />
          <Route path="/bill-payment/create" element={<BillPaymentCreate data-id="element-46" />} data-id="element-45" />
          <Route path="/bill-payment/:id" element={<PlaceholderPage title="Bill Payment Detail" description="View bill payment details" data-id="element-48" />} data-id="element-47" />
          <Route path="/bill-payment/:id/edit" element={<PlaceholderPage title="Edit Bill Payment" description="Edit pending bill payment" data-id="element-50" />} data-id="element-49" />

          {/* All Vouchers List */}
          <Route path="/voucher/all" element={<AllVouchersList data-id="element-52" />} data-id="element-51" />

          {/* Party Management Routes */}
          <Route path="/parties" element={<PartyListPage data-id="element-54" />} data-id="element-53" />
          <Route path="/parties/new" element={<PartyFormPage data-id="element-56" />} data-id="element-55" />
          <Route path="/parties/:id" element={<PlaceholderPage title="Party Detail" description="View party details with transactional ledger and ageing" data-id="element-58" />} data-id="element-57" />
          <Route path="/parties/:id/edit" element={<PartyFormPage data-id="element-60" />} data-id="element-59" />

          {/* Voucher Detail & Edit */}
          <Route path="/voucher/:id" element={<PlaceholderPage title="Voucher Detail" description="View voucher details with approval actions" data-id="element-62" />} data-id="element-61" />
          <Route path="/voucher/:id/edit" element={<PlaceholderPage title="Edit Voucher" description="Edit voucher (only if status allows)" data-id="element-64" />} data-id="element-63" />

          {/* Settings */}
          <Route path="/settings" element={<PlaceholderPage title="Settings" description="Settings page coming soon..." data-id="element-66" />} data-id="element-65" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}